import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

const NewOCLLogo = props => (
  <SvgIcon viewBox='0 0 306.14 111.63' {...props}>
    <circle cx='54.09' cy='55.33' r='54.09' />
    <path d='M177.31,109.42c-29.87,0-54.09-24.22-54.09-54.09s24.22-54.09,54.09-54.09' />
    <circle cx='222.74' cy='28.04' r='27.04' />
    <circle cx='222.74' cy='84.4' r='27.04' />
    <circle cx='279.1' cy='84.4' r='27.04' />
  </SvgIcon>
);

export default NewOCLLogo;
